const newLine = require('./line_end');

function copy(text, html) {
  const aux = document.createElement('div');
  if (html) {
    text = html;
    text = text.replace(/<br\/?>/g, newLine);
    text = text.replace(/\r?\n/g, `<br/>${newLine}`);
  }
  aux.setAttribute('contentEditable', true);
  aux.innerHTML = text;
  document.body.appendChild(aux);
  window.getSelection().selectAllChildren(aux);
  document.execCommand('copy');
  document.body.removeChild(aux);
}

module.exports = { copy };
